import { Heart } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useMember } from "@/site/member";

export function FavButton({ code, size = 18, className = "", testid }) {
  const { member, favs, toggleFav } = useMember(), go = useNavigate(), loc = useLocation();
  const on = !!favs?.has(code);
  const click = async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!member) { toast.message("Favorilere eklemek için giriş yapın"); go(`/giris?next=${encodeURIComponent(loc.pathname + loc.search)}`); return; }
    const v = await toggleFav(code);
    if (v !== undefined) toast.success(v ? "Favorilerinize eklendi" : "Favorilerinizden çıkarıldı");
  };
  return (
    <button type="button" onClick={click} aria-pressed={on} aria-label={on ? "Favorilerden çıkar" : "Favorilere ekle"} title={on ? "Favorilerden çıkar" : "Favorilere ekle"}
      className={`grid place-items-center rounded-full shadow-sm transition-[transform,background-color,color] duration-200 active:scale-90 ${on ? "bg-rose-500 text-white hover:bg-rose-600" : "bg-white/95 text-slate-700 hover:text-rose-500"} ${className}`} data-testid={testid || `fav-btn-${code}`}>
      <Heart size={size} fill={on ? "currentColor" : "none"} />
    </button>
  );
}
